import styled from "styled-components";
import Button from "../../../ui/Button";
import { EditIcon } from "../../../utils/icon.utils";
import { arrayMap } from "../../../utils/array.utils";

export default function CustomerAddress({ data, onEdit }) {
  return (
    <div className="bg-light px-3 py-2 mb-3">
      <p className="mb-0">{data?.type ?? "-"}</p>

      <ul className="list-unstyled mb-0">
        {arrayMap(data?.address, (item, index) => (
          <li key={index}>
            <ListHeading>{item?.label ?? ""}: </ListHeading>
            {item?.value || ""}
          </li>
        )) || <li>No Address</li>}
      </ul>

      <div className="text-end">
        <Button onClick={() => onEdit(data)} name="Edit" icon={EditIcon} />
      </div>
    </div>
  );
}

const ListHeading = styled.span`
  font-weight: 500;
`;
